// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"679":"bb35a422","787":"2a12dffe"}[chunkId] + ".chunk.js";
};